import PropTypes from 'prop-types';

export const RESULT__FINALISE = 'RESULT__FINALISE';
export const RESULT__REDIRECTING = 'RESULT__REDIRECTING';
export const SURVEY_CLIENT__PATCH = 'SURVEY_CLIENT__PATCH';
export const SURVEY_CLIENT__TOGGLE_PROGRESS = 'SURVEY_CLIENT__TOGGLE_PROGRESS';

export const SURVEY_CLIENT__SHAPE_ITEM = PropTypes.shape({
  isInitialized: PropTypes.bool,
  isPreview: PropTypes.bool,
  selectedPageIndex: PropTypes.number,
  showProgress: PropTypes.bool,
  version: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});
